<div class="task-dialog">

  <!-- Header -->
  <div class="task-header">
    <div class="task-header-left">
      <mat-icon class="task-header-icon">assignment_ind</mat-icon>
      <h2>Assign Task</h2>
    </div>
    <button class="close-btn" type="button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Success state -->
  @if (submitted) {
    <div class="success-state">
      <mat-icon class="success-icon">check_circle</mat-icon>
      <p>Task assigned to {{ selectedUsers.length }} {{ selectedUsers.length === 1 ? 'person' : 'people' }}!</p>
    </div>
  }

  @if (!submitted) {

    <!-- Selected recipients chips -->
    @if (selectedUsers.length > 0) {
      <div class="selected-chips">
        @for (u of selectedUsers; track u.id) {
          <span class="chip">
            <span class="chip-avatar">{{ initials(u) }}</span>
            {{ u.name }} {{ u.lastname }}
            <button class="chip-remove" type="button" (click)="removeSelected(u)">
              <mat-icon>close</mat-icon>
            </button>
          </span>
        }
      </div>
    }

    <!-- Task description -->
    <div class="field-group">
      <label class="field-label">Task description <span class="required">*</span></label>
      <textarea
        class="task-textarea"
        placeholder="Describe what needs to be done…"
        [(ngModel)]="taskDescription"
        rows="4">
      </textarea>
    </div>

    <!-- Assign to -->
    <div class="field-group">
      <label class="field-label">Assign to <span class="required">*</span></label>
      <div class="search-box">
        <mat-icon class="search-icon">search</mat-icon>
        <input
          type="text"
          placeholder="Search by name or email…"
          [(ngModel)]="searchText"
          (ngModelChange)="onSearch()" />
      </div>

      @if (loading) {
        <div class="user-list-loading">
          <mat-spinner diameter="28"></mat-spinner>
        </div>
      }

      @if (!loading) {
        <ul class="user-list">
          @for (u of filteredUsers; track u.id) {
            <li class="user-row"
              [class.selected]="isSelected(u)"
              (click)="toggle(u)">
              <span class="user-avatar">{{ initials(u) }}</span>
              <div class="user-info">
                <span class="user-name">{{ u.name }} {{ u.lastname }}</span>
                <span class="user-email">{{ u.email }}</span>
              </div>
              @if (isSelected(u)) {
                <mat-icon class="check-icon">check</mat-icon>
              }
            </li>
          }
          @if (filteredUsers.length === 0) {
            <li class="no-results">No users match "{{ searchText }}"</li>
          }
        </ul>
      }
    </div>

    <!-- Footer -->
    <div class="task-footer">
      <button class="btn-cancel" type="button" (click)="close()">Cancel</button>
      <button
        class="btn-assign"
        type="button"
        [disabled]="!canSubmit"
        [matTooltip]="!taskDescription.trim() ? 'Add a task description' : selectedUsers.length === 0 ? 'Select at least one person' : ''"
        (click)="submit()">
        @if (submitting) {
          <mat-spinner diameter="16"></mat-spinner>
        }
        Assign task
      </button>
    </div>

  }
</div>
